import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getAiAgents } from '@api';

export const getCoreAiAgentSlice = createGetAsyncSlice({
	name: 'coreAiAgent',
	receive: true,
	request: true,
	requestHandler: getAiAgents,
	retainDataOnRequest: false
});
